import React from 'react';
import ReactDOM from 'react-dom';
import axios from 'axios';
import Portal from 'react-portal';
import FullScreenOverlay from '../FullScreenOverlay.js';
import uuidV4 from 'uuid/v4';
import LoadingSmall from '../LoadingSmall.js';
import Discount from '../../containers/discounts/form/Discount.js';
import Notification from '../Notification.js';

class DiscountPicker extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            isLoading:true,
            discounts:[],
            isAdding:false,
            isWaiting:false,
            add:false
        }

        this.handleSubmit = this.handleSubmit.bind(this);
        this.select = this.select.bind(this);

    }

    handleSubmit(values) {
        Notification.info('Saving...');
        this.setState({
            'isAdding':false,
        });
        let method = 'post';
        let url = '/discounts';

        axios[method](url,values)
            .then((response) => {
                this.update();
                window.scrollTo(0, 0);
                this.select(response.data.id);
                Notification.success('Discount saved');
            })
            .catch((error) => {
                Notification.error(error.message);
            });


    }

    update() {
        axios.get(`/discounts`)
        .then(res => {
            this.setState({
                'isLoading':false,
                'discounts':res.data
            });
        });
    }

    select(id) {
        this.setState({
            add:id,
        })

        if(this.props.sidebar === true) {
            this.props.useDiscount(id);
        }else{
            this.setState({
                add:id,
            });
        }
    }

    componentWillMount() {
        this.update();
    }

    render() {
        return <Portal closeOnEsc onClose={this.props.onClose} isOpened={(this.props.param !== false ? true:false)}>
            <FullScreenOverlay>
                <div className="overview m-t-30 col-sm-6 offset-sm-3 m-b-40 text-center">
                    <h1>Add discount</h1>
                    <h2>Select a existing, or add a new discount</h2>

                    {
                        this.state.isLoading ? <LoadingSmall />:null
                    }

                    {
                        this.state.add ?
                            <div className="alert alert-primary alert-dismissible m-t-30 m-b-30" role="alert">
                                Copy and paste the code below into the location where you want the code to appear.<br /><br />
                                <h2 style={{color:'#62a8ea'}}><strong>@@DISCOUNT-{this.state.add}@@</strong></h2><br />
                                <button className="btn btn-primary" onClick={this.props.onClose} type="button">Close window</button>
                            </div>:null
                    }

                    <div className="m-t-0 col-sm-10 offset-sm-1">
                        <ul className="list-group list-group-full">
                            {
                                this.state.discounts.map(discount => {
                                   return (
                                       <li key={discount.id} className="list-group-item">
                                           <div className="media">
                                               <div className="media-left" style={{verticalAlign:'middle'}}>
                                                   <a className="avatar" href="javascript:void(0)" style={{width:'40px'}}>
                                                       <img className="img-fluid" src="/images/svg/select.svg" alt="..." style={{borderRadius:0}} />
                                                   </a>
                                               </div>
                                               <div className="media-body">
                                                   <h4 className="media-heading">{discount.name}</h4>
                                                   {
                                                       discount.auto_update == '1' ?
                                                           <small>Codes from this discount will be automatically generated in your store.</small>
                                                           :
                                                           <small>Manual discount.</small>

                                                   }
                                               </div>
                                               <div className="media-right">
                                                   <button onClick={() => this.select(discount.id)} className="btn btn-dark btn-block">Use</button>
                                               </div>
                                           </div>
                                       </li>
                                   )
                                })
                            }
                        </ul>
                        <div className="m-b-20 strike">
                            <span>New discount</span>
                        </div>
                        {
                            this.state.isAdding ?
                                <Discount errorMessage={this.state.error} initialValues={this.state.discount ? this.state.discount:{expire: 1,type:'percent'}} isWaiting={this.state.isWaiting} onSubmit={this.handleSubmit} />
                                :
                                <button className="btn btn-dark btn-lg" onClick={() => this.setState({isAdding:true})}>Add new discount</button>

                        }
                    </div>


                </div>
            </FullScreenOverlay>
        </Portal>
    }
}

export default DiscountPicker;


// WEBPACK FOOTER //
// ./components/builder/DiscountPicker.js